const allWorkOrder = () =>
    import('@/views/workOrder/allWorkOrder/index.vue');
const myWorkOrder = () =>
    import('@/views/workOrder/myWorkOrder/index.vue');

export default [
    {
        path: "/workOrder/allWorkOrder",
        name: "allWorkOrder",
        components: {
            default: allWorkOrder,
        },
        meta: {
            nav: "workOrder",
            navChild: "allWorkOrder",
            navName:"全部工单",
            keepAlive: true
        },
    },
    {
        path: "/workOrder/myWorkOrder",
        name: "myWorkOrder",
        components: {
            default: myWorkOrder,
        },
        meta: {
            nav: "workOrder",
            navChild: "myWorkOrder",
            navName:"我的工单",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/workOrder/index.js